<template>
  <div class="titleBar" :class="{move: move}">
    <h3>{{ title }}</h3>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String, required: true },
    move: {type: Boolean, default: false}
  },
  created () {
  },
  data () {
    return {
    }
  },
  name: 'TitleBar',
  methods: {
  },
  components: {
  }
}
</script>

<style scoped>
.titleBar {
  height: 40px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: left;
  padding: 0px 10px;
  border-bottom: 1px solid var(--line-base);
}
.titleBar h3 {
  color: var(--text-title);
}
.titleBar.move {
  position: relative;
  border-bottom: 1px solid var(--line-guide);
}
.titleBar.move:hover {
  border: 1px solid var(--line-guide);
}
.titleBar.move:hover::after{
  content: '더보기';
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  font-size: 14px;
  color: #CCCCCC;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/TitleBar.vue